import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=d98afedc&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Page.vue?vue&type=style&index=0&id=d98afedc&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d98afedc",
  "551640f4"
  
)

export default component.exports